import * as __glob_0 from './../_hero-coins.js';
import * as __glob_1 from './../accordion.js';
import * as __glob_2 from './../card-border.js';
import * as __glob_3 from './../coins-animation.js';
import * as __glob_4 from './../coins-gravity.js';
import * as __glob_5 from './../counter.js';
import * as __glob_6 from './../cycle.ts';
import * as __glob_7 from './../dots-animation.js';
import * as __glob_8 from './../form.ts';
import * as __glob_9 from './../ghost-posts.js';
import * as __glob_10 from './../ilya.js';
import * as __glob_11 from './../infrastructure-card.js';
import * as __glob_12 from './../liquidity-progress.js';
import * as __glob_13 from './../logos-wheel.js';
import * as __glob_14 from './../markets-progress.js';
import * as __glob_15 from './../marquee.js';
import * as __glob_16 from './../nav.ts';
import * as __glob_17 from './../purpose-progress.js';
import * as __glob_18 from './../split.ts';
import * as __glob_19 from './../tab.js';
import * as __glob_20 from './../test.ts';
import * as __glob_21 from './../text-animations.js';
const modules = { "./../_hero-coins.js": __glob_0, "./../accordion.js": __glob_1, "./../card-border.js": __glob_2, "./../coins-animation.js": __glob_3, "./../coins-gravity.js": __glob_4, "./../counter.js": __glob_5, "./../cycle.ts": __glob_6, "./../dots-animation.js": __glob_7, "./../form.ts": __glob_8, "./../ghost-posts.js": __glob_9, "./../ilya.js": __glob_10, "./../infrastructure-card.js": __glob_11, "./../liquidity-progress.js": __glob_12, "./../logos-wheel.js": __glob_13, "./../markets-progress.js": __glob_14, "./../marquee.js": __glob_15, "./../nav.ts": __glob_16, "./../purpose-progress.js": __glob_17, "./../split.ts": __glob_18, "./../tab.js": __glob_19, "./../test.ts": __glob_20, "./../text-animations.js": __glob_21 };
// console.log("modules -> []", modules);

// Extend HTMLElement interface to include our custom property
declare global {
  interface HTMLElement {
    _moduleInitialized?: boolean;
  }
}

export function createCycles(dataAttribute = "module") {
  return Array.from(document.querySelectorAll(`[data-${dataAttribute}]`))
    .map((element) => {
      const htmlElement = element as HTMLElement;
      const attributeValue = htmlElement.dataset[dataAttribute];

      // Check if THIS SPECIFIC ELEMENT is already initialized
      if (htmlElement._moduleInitialized) {
        return null; // Skip this specific element
      }

      const modulePath = modules[`./../${attributeValue}.ts`]
        ? `./../${attributeValue}.ts`
        : `./../${attributeValue}.js`;

      if (modules[modulePath]) {
        // Expecting a default export function
        const moduleFn = (
          modules[modulePath] as {
            default: (el: HTMLElement, dataset: DOMStringMap) => any;
          }
        ).default;
        if (typeof moduleFn === "function") {
          try {
            // Mark THIS SPECIFIC ELEMENT as initialized
            htmlElement._moduleInitialized = true;

            return moduleFn(htmlElement, htmlElement.dataset);
          } catch (error) {
            // Remove the flag if initialization fails
            delete htmlElement._moduleInitialized;
            console.warn(
              `Failed to call default function for ${dataAttribute} "${attributeValue}":`,
              error
            );
            return null;
          }
        } else {
          console.warn(
            `Default export is not a function for ${dataAttribute} "${attributeValue}"`
          );
          return null;
        }
      } else {
        console.warn(`${dataAttribute} not found: "${attributeValue}"`);
        return null;
      }
    })
    .filter((item) => item !== null);
}

// Optional: Helper function to manually clear initialization for testing
export function clearModuleInitialization(element: HTMLElement) {
  delete element._moduleInitialized;
}
